import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../../store/useAuthStore";
import { JSX } from "react";
import { returnPathFrom } from "../../hooks/useAuth";

export function GuestOnly({ children }: { children: JSX.Element }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const location = useLocation();

  if (isAuthenticated) {
    return <Navigate to={returnPathFrom(location.state)} replace />;
  }

  return children;
}
